import * as React from 'react';
import styled, {css} from 'styled-components';

export interface InputContainerProps {
  children: React.ReactNode;
  label?: string;
  note?: string;
  error?: string;
  required?: boolean;
}

export const Container = styled.div`
  display: grid;
  gap: 12px;
`;

export const Label = styled.span<InputContainerProps>`
  color: ${({theme}) => theme.variables.inputLabelColor};
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  
  ${({required}) => required && css`
    &:after {
      content: "*";
      color: ${({theme}) => theme.colors.red};
      margin-left: 4px;
    }
  `};
`;

export const Footer = styled.div`
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  display: grid;
`;

export const Note = styled.span`
  color: ${({theme}) => theme.variables.inputNoteColor};
  font-size: 14px;
  font-weight: 500;
  user-select: none;
`;

export const Error = styled.span`
  color: ${({theme}) => theme.colors.red};
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  user-select: none;
`;

/**
 * The containers wrap input in label and error
 * @param {InputContainerProps} props
 * @return {React.ReactElement<InputContainerProps>}
 * @constructor
 */
export default function InputContainer(
    props: InputContainerProps,
): React.ReactElement<InputContainerProps> {
  return (
    <Container>
      {props.label && (
        <Label {...props}>
          {props.label}
        </Label>
      )}
      {props.children}
      {(props.note || props.error) && (
        <Footer>
          {props.note && (
            <Note>
              {props.note}
            </Note>
          )}
          {props.error && (
            <Error>
              {props.error}
            </Error>
          )}
        </Footer>
      )}
    </Container>
  );
}
